module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAASCAYAAACw50UTAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAPdJREFUeNpiYCAOhALxuv///zOQop4YhblADDL1P5GGw9UTUjgVqugwEHMSYTiKelyK2IH4GFThDJggHsOxqscG1IH4HVRhNrIEDsNxqkcHvkjh5YguicVwvOqRQQFU0QsgVsKmAM1wguphYAFU4S4gZsKlCMlwotSDwDWowmpCSQFqONHqQbbeh7LliMwgpKpnaIC65gEQyxIRLESpRwYBhGIeLUIDiE0pMKAPxJ+hGpKJSIp41WMDHEB8BqphKhGZCKd6fGAJVMMeWHIjULZgqCcEiqEanoIyChEFF4p6YizwJbHI9SW2yIUBNyCeQEJlAVYPEGAAzyKBcOn95NwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/ios/left0.png
// module id = HwDa
// module chunks = 0